// Items not configured per environment
const defaultConfig = {
  OUTPUT_DATE_FORMAT: 'DD.MM.YYYY',
  IMAGE_DATE_FORMAT: 'YYYY-MM-DD',
}

export default {...defaultConfig, ...window.ENV}
